import { createBrowserHistory } from "history";

// Create a history object so we can use it on redux actions (ie: redirect user)
export default createBrowserHistory();
